import React from "react"
import { Link } from "gatsby"

const values = [
  {
    title: "Fast Setup",
    content:
      "Woodcore allows you to deploy a banking service of your own without any hassle and you are set up in no time.",
  },
  {
    title: "Smooth Integration",
    content:
      "If you need to integrate with other services, WoodCore allows you to do that seamlessly.",
  },
  {
    title: "Wide Range of Services",
    content:
      "Think of anything in the finserv that your enterprise needs, just say the word WoodCore. We have got you covered.",
  },
  {
    title: "Constant Improvements",
    content:
      "Our process ensures that we are always looking out for the upgrades you need to keep you focused on your operations.",
  },
  {
    title: "Request A Feature",
    content:
      "Suggest features to WoodCore which we can evaluate and add to our releases. Who knows, we can even dedicate it to your enterprise.",
  },
  {
    title: "Support",
    content:
      "We provide you with enough support till you can stand alone. Even when you can, we are always a message away from you",
  },
]

const Values = () => {
  return (
    <section className="bg-snow-100">
      <div className="w-11/12 xl:w-9/12 mx-auto py-24">
        <h4 className="text-4xl text-grey-100 font-semibold xl:w-7/12 mx-auto text-center">
          What Makes WoodCore Unique
        </h4>
        <div className="mt-10 grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {values.map((value, i) => (
            <div className="col-span-1" key={value.title}>
              <div className="border border-grey-300 rounded-lg bg-white py-4 px-4 h-48">
                <div className="flex items-center">
                  <div className="h-10 w-10 bg-smoke-100 rounded-full flex items-center justify-center">
                    <p className="text-green text-lg font-medium">{i + 1}</p>
                  </div>
                  <p className="text-lg text-grey-100 font-medium ml-3">
                    {value.title}
                  </p>
                </div>

                <p
                  className="mt-4 text-grey-200 text-base"
                  style={{ lineHeight: "26px" }}
                >
                  {value.content}
                </p>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-16 text-center">
          <Link
            to="/about"
            className="text-xs text-white font-medium bg-green rounded-sm py-3 px-10 hover:bg-green-dark duration-500"
          >
            Learn more
          </Link>
        </div>
      </div>
    </section>
  )
}

export default Values
